import { call, cancel } from 'redux-saga/effects';
import { GlobalActions, GlobalPut, ModalType } from '@ps20-frontend/shop-integration-redux';
import { ReturnCodeTaas, TaasStatus } from '@ps20/bff-models';
import { App, isAppTypeInList } from '@ps20-frontend/frontend-models';
import { CallEffect, CancelEffect } from '@redux-saga/core/effects'; // NOSONAR

export const FEHLERCODE_ADRESSE_NICHT_TARIFIERBAR = '995000';

export function taasReturnStatus(returnCodeTaas: ReturnCodeTaas): ModalType {
  if (returnCodeTaas === ReturnCodeTaas.FEHLER_VORVERTRAG_NOT_MATCH_OR_NOK) {
    return ModalType.FEHLER_VORVERTRAG_NOT_MATCH_OR_NOK;
  }
  if (returnCodeTaas === ReturnCodeTaas.FEHLER_MIT_RETRY_MIT_VERFUEGBAR) {
    return ModalType.TAAS_FEHLER_MIT_RETRY;
  }
  return ModalType.TAAS_FEHLER_OHNE_RETRY;
}

export function getHTMLBody(fehlerCode: string, fehlermeldung: string): string {
  return `
    <b>Fehlercode: ${fehlerCode}</b>
    <br/><br/>
    ${fehlermeldung}
    <br/><br/>
    `;
}

export function* showTaasStatusModal(
  taasStatus: TaasStatus,
  app?: App,
  angebotsId?: string,
): Generator<CallEffect | CancelEffect> {
  const globalPut = GlobalPut.getInstance();
  const { fehlerCode, fehlermeldung, returnCodeTaas } = taasStatus;
  const body = getHTMLBody(fehlerCode, fehlermeldung);
  const modalTypeForTaasStatus = taasReturnStatus(returnCodeTaas);

  if (adresseNichtTarifierbar(fehlerCode, app)) {
    yield call(
      globalPut.put,
      new GlobalActions().openMapViewModal(app, angebotsId, false, 'angebot'),
    );
    yield cancel();
  } else {
    yield call(globalPut.put, new GlobalActions().requestModal(modalTypeForTaasStatus, { body }));
  }
}

export function adresseNichtTarifierbar(fehlerCode: string, app: App): boolean {
  return (
    fehlerCode === FEHLERCODE_ADRESSE_NICHT_TARIFIERBAR && isAppTypeInList(app, [App.VWG, App.VHV])
  );
}
